import mitt from 'mitt';

window.emitter = mitt();

require('./videos');

window.modals = () => {
    return {
        currentlyShowing: [],
        player: null,
        keydownListener: null,
        shouldShow(id) {
            return this.currentlyShowing.includes(id);
        },
        show(e) {
            const el = document.querySelector(`#modal-${this.getId(e)}`);

            el.style.zIndex =
                100 + document.querySelectorAll('.modal.modal-visible').length;

            this.currentlyShowing.push(this.getId(e));
            document.body.classList.add('overflow-hidden');

            const vimeoEmbed = el.querySelector('.vimeo-embed');

            if (vimeoEmbed) {
                const options = {
                    id: vimeoEmbed.getAttribute('data-url'),
                    width: 640,
                    width: 360,
                    autoplay: true,
                    color: 'f76900',
                };

                this.player = new window.Vimeo.Player(vimeoEmbed, options);
            }

            this.trapFocus(el);
        },
        trapFocus(modal) {
            if (!modal.classList.contains('modal-visible')) {
                // Wait until it's visible to trap focus
                return setTimeout(() => {
                    this.trapFocus(modal);
                }, 500);
            }

            const focusableElements =
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

            const firstFocusableElement = modal.querySelectorAll(
                focusableElements,
            )[0]; // get first element to be focused inside modal
            const focusableContent = modal.querySelectorAll(focusableElements);
            const lastFocusableElement =
                focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

            this.keydownListener = (e) => {
                const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed) {
                    return;
                }

                if (e.shiftKey) {
                    // if shift key pressed for shift + tab combination
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus(); // add focus for the last focusable element
                        e.preventDefault();
                    }
                } else {
                    // if tab key is pressed
                    if (document.activeElement === lastFocusableElement) {
                        // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        firstFocusableElement.focus(); // add focus for the first focusable element
                        e.preventDefault();
                    }
                }
            };

            document.addEventListener('keydown', this.keydownListener);

            firstFocusableElement.focus();
        },
        close(e) {
            if (
                document.querySelectorAll('.modal.modal-visible').length === 1
            ) {
                document.body.classList.remove('overflow-hidden');
            }

            if (this.player) {
                this.player.pause();
                this.player = null;
            }

            this.currentlyShowing = this.currentlyShowing.filter(
                (id) => id !== this.getId(e),
            );

            document.removeEventListener('keydown', this.keydownListener);
        },
        getId(e) {
            return typeof e.detail === 'string' ? e.detail : e.detail.id;
        },
    };
};
